/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Privacypolicy_Title1Inputs */

const he_seo_privacypolicy_title1 = /** @type {(inputs: Seo_Privacypolicy_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מדיניות פרטיות - Pricedrop`)
};

const en_seo_privacypolicy_title1 = /** @type {(inputs: Seo_Privacypolicy_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy - Pricedrop`)
};

/**
* | output |
* | --- |
* | "Privacy Policy - Pricedrop" |
*
* @param {Seo_Privacypolicy_Title1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const seo_privacypolicy_title1 = /** @type {((inputs?: Seo_Privacypolicy_Title1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Privacypolicy_Title1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_privacypolicy_title1(inputs)
	return en_seo_privacypolicy_title1(inputs)
});
export { seo_privacypolicy_title1 as "seo_privacyPolicy_title" }